import { render, staticRenderFns } from "./tmp-news-info-cn.vue?vue&type=template&id=4529f08e&"
import script from "./tmp-news-info-cn.vue?vue&type=script&lang=js&"
export * from "./tmp-news-info-cn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports